<template functional>
  <inline-svg
    src="img/cpu.svg"
    v-bind="data.attrs"
    :class="data.staticClass || ''"
    :style="{ height: props.height, width: props.width }"
  />
</template>

<script>
import Vue from 'vue'
import InlineSvg from 'vue-inline-svg'

Vue.component('inline-svg', InlineSvg)
export default {
  name: 'cpu-logo'
}
</script>
